import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";
export const postPreferencesService = (token, data) =>
  axios({
    method: "post",
    url: "",
    headers: {
      ...headers,
      "X-Access-Token": token,
    },
    data: {
      ...data,
    },
  });

export const putPreferencesService = (token, data) =>
  axios({
    method: "put",
    url: `${api}/v1/configs`,
    headers: {
      ...headers,
      "X-Access-Token": token,
    },
    data: data,
  });

export const getCompanyConfigService = (token) =>
  axios({
    method: "get",
    url: `${api}/v1/configs`,
    headers: {
      ...headers,
      "X-Access-Token": token,
    },
  });
